import { defineStore } from "pinia";

export const useClassStore = defineStore("class", {
  state: () => {
    return {
      classList: [],
      selectClass: "",
      selectClassId: "",
      kindOfRes: [],
      kindOfResOfdisplay: [],
    };
  },
  getters: {
    dailyGoalBook(state) {
      let tempBook = [];
      if (state.classList && state.classList.length !== 0) {
        // console.log("bclass List = ", state.classList);
        // console.log("state.selectClassId = ", state.selectClassId);
        state.classList.forEach((ci) => {
          if (ci.courseid === state.selectClassId) {
            // 等於選擇的班級
            if (
              ci.dailyMission &&
              ci.dailyMission.record.length !== 0 &&
              Array.isArray(ci.dailyMission.record)
            ) {
              console.log(ci.dailyMission.record);
              ci.dailyMission.record.forEach((cib) => {
                // console.log("cib!!!!!!!!!!!!!");
                // console.log(cib);
                if (cib.resource_type === "book") {
                  // console.log("push = ", cib);
                  cib.cid = ci.courseid;
                  tempBook.push(cib);
                }
              });
            }
          }
        });
      }
      return tempBook;
    },
    dailyGoalVideo(state) {
      let tempVideo = [];
      if (state.classList && state.classList.length !== 0) {
        // console.log("vclass List = ", state.classList);
        // console.log("state.selectClassId = ", state.selectClassId);
        state.classList.forEach((ci) => {
          if (ci.courseid === state.selectClassId) {
            if (
              ci.dailyMission &&
              ci.dailyMission.record.length !== 0 &&
              Array.isArray(ci.dailyMission.record)
            ) {
              ci.dailyMission.record.forEach((civ) => {
                // console.log("civ!!!!!!!!!!!!!");
                // console.log(civ);
                if (civ.resource_type === "video") {
                  // console.log("push = ", civ);
                  civ.cid = ci.courseid;
                  tempVideo.push(civ);
                }
              });
            }
          }
        });
      }
      return tempVideo;
    },
  },
  actions: {},
  persist: true,
});
